"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getTheme = getTheme;
exports.getThemeHeader = getThemeHeader;
exports.updateTheme = updateTheme;
exports.setThemeType = exports.themeType = exports.themeCookieName = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _environment = require("../environment");

var _utils = require("../utils");

var _internals = require("../utils/internals");

var themeCookieName = 'bmTheme';
exports.themeCookieName = themeCookieName;
var themeType = 'staff';
exports.themeType = themeType;

var setThemeType = function setThemeType(type) {
  exports.themeType = themeType = type;
};

exports.setThemeType = setThemeType;

function getTheme() {
  return _getTheme.apply(this, arguments);
}

function _getTheme() {
  _getTheme = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
    var companyId,
        firmId,
        _args3 = arguments;
    return _regenerator.default.wrap(function _callee3$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            companyId = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
            firmId = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : '';
            return _context5.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context, _context2;

              return (0, _concat.default)(_context = (0, _concat.default)(_context2 = "".concat(base, "/v1/themes?company=")).call(_context2, companyId, "&firm=")).call(_context, firmId);
            }).then( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
                return _regenerator.default.wrap(function _callee$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x4) {
                return _ref.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(response) {
                return _regenerator.default.wrap(function _callee2$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee2);
              }));

              return function (_x5) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee3);
  }));
  return _getTheme.apply(this, arguments);
}

function getThemeHeader(_x) {
  return _getThemeHeader.apply(this, arguments);
}

function _getThemeHeader() {
  _getThemeHeader = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(companyId) {
    return _regenerator.default.wrap(function _callee6$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context6;

              return (0, _concat.default)(_context6 = "".concat(base, "/v1/themes/header?company=")).call(_context6, companyId);
            }).then( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(url) {
                return _regenerator.default.wrap(function _callee4$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        return _context7.abrupt("return", fetch(url, {
                          headers: (0, _utils.jsonHeaders)()
                        }));

                      case 1:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee4);
              }));

              return function (_x6) {
                return _ref3.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(response) {
                return _regenerator.default.wrap(function _callee5$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        return _context8.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x7) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee6);
  }));
  return _getThemeHeader.apply(this, arguments);
}

function updateTheme(_x2, _x3) {
  return _updateTheme.apply(this, arguments);
}

function _updateTheme() {
  _updateTheme = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(theme, companyId) {
    return _regenerator.default.wrap(function _callee9$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", (0, _environment.getRoute)('ProfileServices').then(function (base) {
              var _context10;

              return (0, _concat.default)(_context10 = "".concat(base, "/v1/themes?company=")).call(_context10, companyId);
            }).then( /*#__PURE__*/function () {
              var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url) {
                return _regenerator.default.wrap(function _callee7$(_context11) {
                  while (1) {
                    switch (_context11.prev = _context11.next) {
                      case 0:
                        return _context11.abrupt("return", fetch(url, {
                          body: (0, _stringify.default)(theme),
                          headers: (0, _utils.jsonHeaders)(),
                          method: 'PUT'
                        }));

                      case 1:
                      case "end":
                        return _context11.stop();
                    }
                  }
                }, _callee7);
              }));

              return function (_x8) {
                return _ref5.apply(this, arguments);
              };
            }()).then(_internals.http500Thrower).then( /*#__PURE__*/function () {
              var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(response) {
                return _regenerator.default.wrap(function _callee8$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        return _context12.abrupt("return", response.json());

                      case 1:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee8);
              }));

              return function (_x9) {
                return _ref6.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee9);
  }));
  return _updateTheme.apply(this, arguments);
}
